module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('categoria.titulos.titulo'),
      "subTitle": _vm.$t('categoria.titulos.subtitulo')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('categoria.labels.novaCategoria'),
      "id": "btnCriarNovaCategoria",
      "clickFunction": _vm.createEditCategory
    },
    slot: "new-button"
  }), _c('div', {
    staticClass: "clear"
  })], 1), _c('div', {
    attrs: {
      "id": "categories"
    }
  }, [(_vm.isLoadingDataGeneral) ? _c('div', {
    staticClass: "isLoadingDataGeneral"
  }) : _vm._e(), (_vm.categories && _vm.categories.length > 0) ? _c('div', [_c('div', {
    staticClass: "categories-header"
  }, [_c('div', {
    staticClass: "col-xs-5 col-sm-7 col-md-6 col-lg-4 categories-header-column-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.descricao'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 categories-type",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.modal.labels.tipo'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 categories-initial-balance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.modal.labels.saldoInicial'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 categories-initial-balance-date",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.modal.labels.dataSaldoInicial'))
    }
  }), _c('div', {
    staticClass: "pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-1"
  }, [_c('div', {
    staticClass: "categories-header-acoes-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _vm._l((_vm.categories), function(category) {
    return _c('div', [_c('vue-drag-tree', {
      staticClass: "vue-drag-tree",
      attrs: {
        "model": category,
        "clickFunction": _vm.createEditCategory,
        "clickRemoveFunction": _vm.handleRemove,
        "showRemove": true,
        "father": category,
        "id": category.id,
        "buttonsTitle": _vm.treeViewButtonTitle,
        "current-highlight": false,
        "default-text": null,
        "hover-color": "lightblue"
      }
    }), _c('div', {
      staticClass: "clear"
    })], 1)
  })], 2) : _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.resultadoVazio'))
    }
  })])])], 1)]), (_vm.shown) ? _c('categorie-modal', {
    attrs: {
      "idEditingCategory": _vm.idEditingCategory,
      "subCategoryParent": _vm.parentCategory,
      "categories": _vm.categories,
      "lastCategoryOrder": _vm.lastCategoryOrder
    },
    on: {
      "close-modal": function($event) {
        _vm.shown = false
      }
    }
  }) : _vm._e(), _c('confirm-modal', {
    attrs: {
      "id": "confirmRemoveCategory"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.confirmarDelete'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoverCategory",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "disabled": _vm.requestSentRemove,
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmarModalRemoverCategory",
      "clickFunction": _vm.removeCategory
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-648087e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-648087e0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/categories/list.pug
// module id = 1424
// module chunks = 0